module.exports = __webpack_public_path__ + "img/email.3278b3fa.svg";